import { PlessJsonResponderSub } from 'src/app/commons/kymw00/pless-json-responder-sub.service';
import { KYMW7000Model } from '../kymw7000.model';
import { Injectable } from '@angular/core';
import { PlessHttp } from '../../../../shared/http/pless-http.service';
import { PlessDialogServiceSub } from '../../../../commons/kymw00/pless-dialog-service-sub';
import { PlessRequest } from 'src/app/shared/vo/pless-request.model';
import { PlessViewUtilsSub } from 'src/app/commons/kymw00/pless-view-utils-sub.service';

// レスポンス構造
type SelectionRequestList = {
  BuyerRequestId: string
  FeatureCode: string
  FeatureName: string
  ClassCode: string
  ClassName: string
  MiddleClassCode: string
  MiddleClassName: string
  PCode: string
  GuideGoodsName: string
  GuideStandardName: string
  PricePattern: string
  ThisTimeSupplyPrice: string
  SupplyPriceStandard: string
  SupplyPriceSpecial1: string
  SupplyPriceSpecial2: string
  ThisTimeCostPrice: string
  CostPriceStandard: string
  CostPriceSpecial1: string
  CostPriceSpecial2: string
  PredictPlanNum: string
  PlanNum: string
  PlanSupplyBudget: string
  RequestStatus: string
  Remarks: string
}[];

export interface GetSelectionRequestListResponse {
  FeatureRequestList: SelectionRequestList
}

/**
 * 表紙特集選定依頼一覧取得サービス
 * @export GetSelectionRequestListService
 * @class GetSelectionRequestListService
 * @extends {PlessJsonResponderSub}
 */
@Injectable()
export class GetSelectionRequestListService extends PlessJsonResponderSub<GetSelectionRequestListResponse> {
  model: KYMW7000Model;
  private calbak: (data: GetSelectionRequestListResponse) => void;

  constructor(
    protected plessHttp: PlessHttp,
    protected dialogService: PlessDialogServiceSub
  ) {
    super(plessHttp, dialogService);
  }

  /**
   * bodyにセットする値を返す
   *
   * @private
   * @returns {PlessRequest} リクエストJSON
   * @memberof GetSelectionRequestListService
   */
  private getBody(): PlessRequest {
    const searchObj = {
      getFeatureList: {
        condition: {
          OrderCode: this.model.orderCode,
          MediumType: this.model.mediumType,
          FeatureCode: this.model.featureCode
        }
      }
    }

    return new PlessRequest({ search: searchObj });
  }

  /**
   * API呼び出し
   *
   * @param model
   * @memberof GetSelectionRequestListService
   */
  execute(model: KYMW7000Model, f?: (data: GetSelectionRequestListResponse) => void): void {
    this.model = model;
    if (f) this.calbak = f;
    this.send('getSelectionRequestList', this.getBody());
  }

  /**
   * API通信成功時の処理
   *
   * @param {*} data レスポンスデータ
   * @memberof GetSelectionRequestListService
   */
  success(data: GetSelectionRequestListResponse) {
    if (this.calbak) this.calbak(data);
  }

  /**
   * 文字列から数値の変換
   * @param value 
   * @returns 
   */
  public convertStrToNum(value: string): number {
    if(!PlessViewUtilsSub.isEmpty(value)) {
      return Number(value);
    }
  }

  /**
   * 業務エラー時のメソッド
   * @param errList サーバ受信データ
   * 機能独自の処理を行う場合、このメソッドをオーバーライドして処理を実装する。
   */
  public plessErrorHandler(errList: Object): void {
    super.plessErrorHandler(errList);
  }

  /**
   * 特殊なエラーが返ってきた場合に呼び出されるメソッド。<br/>
   * 機能独自のステータスコードを持つ場合、このメソッドをオーバーライドして処理を実装する。
   */
  public exceptionError(status: string, result: any): void {
    super.exceptionError(status, result);
  }
}
